import { CustomerStatus } from "src/types";

// Codes must match backoffice-backend CUSTOMER_STATUS_CHANGE.REASONS, which
// rejects a code that isn't listed for the status being changed to.
export const STATUS_REASON_OTHER = "OTHER";
export const STATUS_REASON_DETAIL_MIN_LENGTH = 2;
export const STATUS_REASON_DETAIL_MAX_LENGTH = 200;

export type StatusReasonOption = { value: string; label: string };

export const STATUS_REASON_OPTIONS: Record<CustomerStatus, StatusReasonOption[]> = {
  [CustomerStatus.ACTIVE]: [
    { value: "NO_ISSUE_FOUND", label: "ตรวจสอบแล้วไม่พบความผิดปกติ" },
    { value: "IDENTITY_VERIFIED", label: "ลูกค้ายืนยันตัวตนครบแล้ว" },
    { value: "UNLOCK_REQUESTED_BY_TICKET", label: "ลูกค้าขอปลดล็อคผ่าน Ticket" },
    { value: STATUS_REASON_OTHER, label: "อื่น ๆ" },
  ],
  [CustomerStatus.DISABLED]: [
    { value: "SUSPECTED_FRAUD", label: "สงสัยทุจริต / ใช้บัญชีผู้อื่น" },
    { value: "DUPLICATE_ACCOUNT", label: "บัญชีซ้ำ (คนเดียวหลายยูส)" },
    { value: "CLOSE_REQUESTED_BY_CUSTOMER", label: "ลูกค้าขอปิดบัญชี" },
    { value: "ORDERED_BY_RISK_TEAM", label: "ฝ่ายความเสี่ยงสั่งระงับ" },
    { value: STATUS_REASON_OTHER, label: "อื่น ๆ" },
  ],
  [CustomerStatus.BLOCKED]: [
    { value: "SUSPECTED_ACCOUNT_TAKEOVER", label: "ลูกค้าแจ้งสงสัยถูกเข้าบัญชี" },
    { value: STATUS_REASON_OTHER, label: "อื่น ๆ" },
  ],
};

export const mapToStatusReasonText = (
  status: CustomerStatus,
  reason: string,
  detail?: string | null
): string => {
  if (reason === STATUS_REASON_OTHER && detail) return detail;
  return STATUS_REASON_OPTIONS[status]?.find((option) => option.value === reason)?.label || reason;
};
